import { createApi } from '@reduxjs/toolkit/dist/query/react';

import fetchBaseQuery from '../fetchBaseQuery';

export type Language = {
    id: number;
    name: string;
    langIso: string;
};

export const languagesApi = createApi({
    reducerPath: 'languages',
    baseQuery: fetchBaseQuery(),
    tagTypes: ['languages'],
    endpoints: (builder) => ({
        getLanguages: builder.query<Language[], void>({
            query: () => ({
                method: 'GET',
                url: `/languages?fields[0]=id&fields[1]=name&fields[2]=langIso`,
            }),
            providesTags: ['languages'],
        }),
    }),
});

export const { useGetLanguagesQuery } = languagesApi;

export default languagesApi;
